import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const API = '';

const fmtTarih = (t) => {
  if (!t) return '-';
  return new Date(t).toLocaleDateString('tr-TR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
};
const fmtKisa = (t) => {
  if (!t) return '-';
  return new Date(t).toLocaleDateString('tr-TR', { day: '2-digit', month: 'long' });
};
const fmtOturum = (g) => `${fmtTarih(g?.tarih)}${g?.saat ? ` · ${g.saat}` : ''}${g?.gun_adi ? ` · ${g.gun_adi}` : ''}`;

const DURUM_LABEL = {
  taslak:          { txt: 'Taslak',             color: '#64748B', bg: '#F8FAFC', border: '#E2E8F0' },
  aktif:           { txt: 'Seçim Açık ✅',       color: '#047857', bg: '#ECFDF5', border: '#A7F3D0' },
  secim_kapali:    { txt: 'Seçim Kapandı 🔒',   color: '#B45309', bg: '#FFFBEB', border: '#FDE68A' },
  dagilim_yapildi: { txt: 'Dağılım Hazır 🦋',   color: '#1D4ED8', bg: '#EFF6FF', border: '#BFDBFE' },
  tamamlandi:      { txt: 'Tamamlandı 🏁',      color: '#475569', bg: '#F8FAFC', border: '#CBD5E1' },
};

function KelebekKart({ kelebek, onSecimYap, onSecimIptal, submitting }) {
  const [confirm, setConfirm] = useState(null); // gun_id
  const [degistirmeModu, setDegistirmeModu] = useState(false);
  const durum = DURUM_LABEL[kelebek.durum] || DURUM_LABEL.aktif;
  const secim = kelebek.ogrenci_secim;
  const yerlesim = kelebek.ogrenci_yerlesim;
  const bugun = new Date().toISOString().split('T')[0];
  const secimAcik = kelebek.durum === 'aktif'
    && bugun >= kelebek.baslangic_tarihi
    && bugun <= kelebek.bitis_tarihi;

  return (
    <div style={{
      background: 'var(--bg-card)',
      border: '1.5px solid var(--border)',
      borderRadius: 'var(--r-lg)', overflow: 'hidden',
      boxShadow: 'var(--shadow-card)'
    }}>
      {/* Üst Banner */}
      <div style={{
        background: kelebek.durum === 'aktif'
          ? 'linear-gradient(135deg, rgba(37,99,235,0.08), rgba(232,51,74,0.05))'
          : 'var(--bg-card-hover)',
        padding: '20px 24px',
        borderBottom: '1px solid var(--border)'
      }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: '1.05rem', color: 'var(--text-primary)', marginBottom: 4 }}>
              🦋 {kelebek.ad}
            </div>
            {kelebek.deneme_adi && (
              <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)' }}>📝 {kelebek.deneme_adi}</div>
            )}
          </div>
          <span style={{
            padding: '4px 12px', borderRadius: 20, fontSize: '0.75rem', fontWeight: 700,
            color: durum.color, background: durum.bg,
            border: `1px solid ${durum.border}`, whiteSpace: 'nowrap'
          }}>
            {durum.txt}
          </span>
        </div>

        <div style={{ marginTop: 12, fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
          📅 Kayıt dönemi: {fmtKisa(kelebek.baslangic_tarihi)} — {fmtKisa(kelebek.bitis_tarihi)}
        </div>
      </div>

      <div style={{ padding: '20px 24px' }}>

        {/* Mevcut Seçim Gösterimi */}
        {secim && (
          <div style={{
            padding: 14, borderRadius: 12, marginBottom: 18,
            background: 'var(--success-dim)', border: '1px solid var(--success-border)'
          }}>
            <div style={{ fontWeight: 800, color: '#047857', marginBottom: 4, fontSize: '0.85rem' }}>
              ✅ Seçiminiz Kaydedildi
            </div>
            <div style={{ color: '#065F46', fontSize: '0.95rem', fontWeight: 800 }}>
              {fmtOturum(secim)}
            </div>
            {secimAcik && !degistirmeModu && (
              <button onClick={() => setDegistirmeModu(true)} style={{
                marginTop: 8, padding: '4px 12px', borderRadius: 6,
                border: '1px solid var(--success-border)',
                background: '#FFFFFF', color: '#047857',
                cursor: 'pointer', fontSize: '0.78rem'
              }}>
                Değiştir
              </button>
            )}
          </div>
        )}

        {/* Yerleşim Bilgisi */}
        {yerlesim && (
          <div style={{
            padding: 18, borderRadius: 12, marginBottom: 18,
            background: 'linear-gradient(135deg, #EFF6FF 0%, #FFFFFF 62%, #FFF1F2 100%)',
            border: '1.5px solid var(--border-blue)'
          }}>
            <div style={{ fontWeight: 800, color: 'var(--text-primary)', marginBottom: 12, fontSize: '0.92rem' }}>
              🦋 Oturma Yeriniz Hazır!
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
              {[
                ['🏛️', 'Salon', yerlesim.salon_adi],
                ['↕️', 'Sıra No', `${yerlesim.sira_no}. Sıra`],
                ['↔️', 'Koltuk No', `${yerlesim.sutun_no}. Koltuk`],
              ].map(([icon, lbl, val]) => (
                <div key={lbl} style={{
                  textAlign: 'center', padding: '10px 8px',
                  borderRadius: 10, background: '#FFFFFF',
                  border: '1px solid var(--border)', boxShadow: 'var(--shadow-sm)'
                }}>
                  <div style={{ fontSize: '1.2rem', marginBottom: 2 }}>{icon}</div>
                  <div style={{ fontSize: '1rem', fontWeight: 900, color: 'var(--text-primary)' }}>{val}</div>
                  <div style={{ fontSize: '0.68rem', color: 'var(--text-secondary)', fontWeight: 700 }}>{lbl}</div>
                </div>
              ))}
            </div>
            <div style={{
              marginTop: 12, padding: '10px 12px', borderRadius: 8,
              background: 'var(--bg-input)', textAlign: 'center',
              border: '1px solid var(--border)'
            }}>
              <span style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', fontWeight: 700 }}>
                Masa Kodu: </span>
              <span style={{ fontSize: '0.95rem', fontWeight: 900, color: 'var(--blue)', fontFamily: 'monospace' }}>
                {yerlesim.masa_kodu}
              </span>
              <div style={{ marginTop: 5, fontSize: '0.76rem', color: 'var(--text-secondary)' }}>
                {yerlesim.salon_adi} içinde {yerlesim.sira_no}. sırada, {yerlesim.sutun_no}. koltukta oturacaksınız.
              </div>
            </div>
          </div>
        )}

        {/* Oturum Seçim Kartları */}
        {(secimAcik || (!secim && kelebek.durum === 'aktif')) && (!secim || degistirmeModu) && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 12 }}>
              <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', fontWeight: 800, letterSpacing: '0.04em' }}>
                {secim ? 'OTURUM DEĞİŞTİR:' : 'SINAV OTURUMU SEÇİN:'}
              </div>
              {secim && (
                <button
                  onClick={() => { setDegistirmeModu(false); setConfirm(null); }}
                  style={{
                    padding: '4px 10px', borderRadius: 6,
                    border: '1px solid var(--border-strong)',
                    background: '#FFFFFF', color: 'var(--text-secondary)',
                    cursor: 'pointer', fontSize: '0.75rem'
                  }}
                >
                  Vazgeç
                </button>
              )}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {kelebek.gunler?.map(g => {
                const dolu = g.mevcut_kayit >= g.kontenjan;
                const secili = secim?.gun_id === g.id || confirm === g.id;
                const dolulukYuzde = g.kontenjan > 0 ? Math.min(100, (g.mevcut_kayit / g.kontenjan) * 100) : 0;
                const kalan = g.kontenjan - g.mevcut_kayit;

                return (
                  <div key={g.id} style={{
                    borderRadius: 12, overflow: 'hidden',
                    border: `1px solid ${secili ? 'var(--border-blue)' : dolu ? 'rgba(232,51,74,0.25)' : 'var(--border)'}`,
                    background: secili ? 'var(--blue-dim)' : dolu ? 'var(--danger-dim)' : '#FFFFFF',
                    transition: 'all 0.2s',
                    opacity: dolu && !secili ? 0.72 : 1
                  }}>
                    <div style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                        <div>
                          <div style={{ fontWeight: 800, color: dolu ? 'var(--text-muted)' : 'var(--text-primary)', fontSize: '0.9rem' }}>
                            {fmtTarih(g.tarih)}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: 2 }}>
                            {g.saat ? `Saat ${g.saat}` : 'Saat belirtilmedi'}{g.gun_adi ? ` · ${g.gun_adi}` : ''}
                          </div>
                        </div>
                        <div style={{ textAlign: 'right', flexShrink: 0 }}>
                          {dolu ? (
                            <span style={{ fontSize: '0.75rem', color: 'var(--danger)', fontWeight: 800 }}>⛔ Kontenjan Doldu</span>
                          ) : (
                            <span style={{ fontSize: '0.75rem', color: '#047857', fontWeight: 800 }}>
                              {kalan} yer kaldı
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Doluluk barı */}
                      <div style={{ marginTop: 10, height: 5, borderRadius: 3, background: 'var(--bg-elevated)' }}>
                        <div style={{
                          height: '100%', borderRadius: 3,
                          width: `${dolulukYuzde}%`, transition: 'width 0.4s',
                          background: dolulukYuzde >= 100 ? 'var(--danger)' : dolulukYuzde >= 80 ? 'var(--warning)' : 'var(--success)'
                        }} />
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4, fontSize: '0.68rem', color: 'var(--text-secondary)' }}>
                        <span>{g.mevcut_kayit} kayıtlı</span>
                        <span>{g.kontenjan} kapasite</span>
                      </div>

                      {/* Seçim Butonu */}
                      {secili && secim?.gun_id === g.id ? (
                        <div style={{
                          marginTop: 10, padding: '8px 10px', borderRadius: 8,
                          background: 'var(--success-dim)',
                          border: '1px solid var(--success-border)',
                          color: '#047857', fontSize: '0.78rem', fontWeight: 800,
                          textAlign: 'center'
                        }}>
                          Mevcut seçili oturum
                        </div>
                      ) : !dolu && (
                        <div style={{ marginTop: 10 }}>
                          {confirm === g.id ? (
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                              <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', flex: 1 }}>Emin misiniz?</span>
                              <button
                                onClick={() => { onSecimYap(kelebek.id, g.id); setConfirm(null); setDegistirmeModu(false); }}
                                disabled={submitting}
                                style={{
                                  padding: '6px 16px', borderRadius: 8, border: 'none',
                                  background: 'var(--blue)',
                                  color: '#fff', cursor: submitting ? 'not-allowed' : 'pointer',
                                  fontWeight: 700, fontSize: '0.8rem'
                                }}
                              >
                                {submitting ? '⏳' : '✓ Evet, Seç'}
                              </button>
                              <button
                                onClick={() => setConfirm(null)}
                                style={{
                                  padding: '6px 12px', borderRadius: 8,
                                  border: '1px solid var(--border-strong)',
                                  background: '#FFFFFF', color: 'var(--text-secondary)',
                                  cursor: 'pointer', fontSize: '0.8rem'
                                }}
                              >İptal</button>
                            </div>
                          ) : (
                            <button
                              onClick={() => setConfirm(g.id)}
                              style={{
                                width: '100%', padding: '8px', borderRadius: 8,
                                border: '1px solid var(--border-blue)',
                                background: 'var(--blue-dim)',
                                color: 'var(--blue)', cursor: 'pointer',
                                fontWeight: 800, fontSize: '0.82rem',
                                transition: 'all 0.15s'
                              }}
                            >
                              Bu Oturumu Seç →
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Seçim yoksa ve kapalıysa */}
        {!secim && !secimAcik && kelebek.durum === 'aktif' && (
          <div style={{
            padding: 14, borderRadius: 10,
            background: 'var(--warning-dim)', border: '1px solid rgba(245,158,11,0.25)',
            fontSize: '0.82rem', color: '#92400E', textAlign: 'center'
          }}>
            ⏳ Seçim dönemi henüz başlamadı.<br />
            <span style={{ opacity: 0.7 }}>{fmtKisa(kelebek.baslangic_tarihi)} tarihinde açılacak.</span>
          </div>
        )}

        {!secim && kelebek.durum === 'secim_kapali' && (
          <div style={{
            padding: 14, borderRadius: 10,
            background: 'var(--danger-dim)', border: '1px solid rgba(232,51,74,0.22)',
            fontSize: '0.82rem', color: 'var(--danger)', textAlign: 'center'
          }}>
            🔒 Seçim dönemi sona erdi. Bu denemeye gün seçimi yapamadınız.
          </div>
        )}
      </div>
    </div>
  );
}

// ── Ana Sayfa ─────────────────────────────────────────────────
export default function OgrenciKelebekPage() {
  const [kelebekler, setKelebekler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/ogrenci/kelebek-aktif`);
      if (data.success) setKelebekler(data.data);
    } catch {
      toast.error('Veriler yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSecimYap = async (kelebek_id, gun_id) => {
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/ogrenci/kelebek-sec`, { kelebek_id, gun_id });
      if (data.success) {
        toast.success(data.message);
        load();
      } else {
        toast.error(data.message);
      }
    } catch (e) {
      toast.error(e.response?.data?.message || 'Hata oluştu');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '0 0 40px' }}>
      {/* Başlık */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800, color: 'var(--text-primary)' }}>
          🦋 Kelebek Sınavı
        </h1>
        <p style={{ margin: '6px 0 0', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
          Deneme sınavınız için gün ve saat oturumu seçin. Kapasite dolmadan yerinizi ayırtın.
        </p>
      </div>

      {/* Bilgi Kutusu */}
      <div style={{
        padding: '14px 18px', borderRadius: 12, marginBottom: 24,
        background: 'var(--blue-dim)', border: '1px solid var(--border-blue)',
        fontSize: '0.82rem', color: 'var(--text-secondary)', lineHeight: 1.6
      }}>
        <strong style={{ color: 'var(--blue)' }}>ℹ️ Nasıl çalışır?</strong><br />
        İstediğiniz sınav oturumunu seçin. Okulunuzun öğrencileri, aynı sınıf seviyesindekiler yan yana 
        gelmeyecek şekilde otomatik olarak yerleştirilir. Dağılım yapıldıktan sonra masa kodunuz burada görünür.
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ fontSize: '2rem', marginBottom: 12 }}>🦋</div>
          <div style={{ color: 'var(--text-secondary)' }}>Yükleniyor...</div>
        </div>
      ) : kelebekler.length === 0 ? (
        <div style={{
          textAlign: 'center', padding: 60,
          background: 'var(--bg-card)', borderRadius: 16,
          border: '1px dashed var(--border-strong)', boxShadow: 'var(--shadow-card)'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: 12 }}>🦋</div>
          <div style={{ color: 'var(--text-secondary)', marginBottom: 6 }}>Şu an aktif kelebek kaydı yok</div>
          <div style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>Yeni sınav duyurulduğunda burada görünecek</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {kelebekler.map(k => (
            <KelebekKart
              key={k.id}
              kelebek={k}
              onSecimYap={handleSecimYap}
              submitting={submitting}
            />
          ))}
        </div>
      )}
    </div>
  );
}
